import React from 'react';
import ReactDOM from 'react-dom/client';
import { App as AntdApp, ConfigProvider } from 'antd';
import esES from 'antd/locale/es_ES';
import './index.css';
import App from './App';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  process.env.NODE_ENV === "development" ? (
    <ConfigProvider locale={esES}>
      <AntdApp>
        <App />
      </AntdApp>
    </ConfigProvider>
  ) : (
      <React.StrictMode>
        <ConfigProvider locale={esES}>
          <AntdApp>
            <App />
          </AntdApp>
        </ConfigProvider>
      </React.StrictMode>
  )
);